<template>
  <div>
    <div class="header">
      <span class="h_back" @click="back"></span>
      <span class="h_title">{{detail.name}}</span>
      <span class="h_chack off" v-if="!isCollect" @click="collect"></span>
      <span class="h_chack on" v-else @click="collect"></span>
    </div>
    <div class="h_msg">
      <div class="h_img">
        <img :src="detail.imageUrl" alt="" class="h_imgbg">
      </div>
      <p class="cp_name">{{detail.name}}</p>
      <ul class="cp_base">
        <li><img src="static/images/mum_time.svg" alt=""><span>{{detail.staticCloseDay}}</span></li>
        <li class="mum_li"><img src="static/images/mapbg.svg" alt=""><span class="cp_mum">{{detail.detailAddress}}</span><span class="mapnav">地图</span><img src="static/images/cp_rightbtn.svg" alt="" class="gotomap" v-on:click="goRouter('map')"></li>
      </ul>
      <div class="nav_item">
        <span v-for="(tab,index) in tabList" :class="{active:tabNum==index}" @click="tabChange(index)">{{tab}}</span>
      </div>
      <div class="cp_content" v-show="tabNum==0">
        {{detail.description}}
      </div>
      <div class="zhanlan_content" v-show="tabNum==1">
        <div class="zhanlan_item" v-for="items in spreadtrums" @click="goRouter('zhanlan',items.id)">
          <img :src="items.picUrl" alt="" class="slideLeft">
          <div class="slideRight">
            <p class="headline">{{items.headline}}</p>
            <p class="zhanlanadress">{{items.viMoveUrl}}</p>
            <p class="zhanlantime" v-if="items.exhibitionType==0">{{items.beginDate}}-{{items.endDate}}</p>
            <p class="zhanlantime" v-else>常设展览</p>
            <p class="zhanlanlimit"  v-if="items.exhibitionType==0">{{items.closeDays == 0 ? '已经完成' : items.closeDays + '天后闭展'}}</p>
            <p class="zhanlanlimit" v-else></p>
          </div>
        </div>
      </div>
      <div class="collect_content" v-show="tabNum==2">
        <div class="collect_item" v-for="items in collections" @click="goRouter('cangp',items.id)">
          <img :src="items.pics[0] && items.pics[0].url || ''" :onerror="defaultImg" alt="" >
          <p class="ellipse">{{items.name}}</p>
        </div>
      </div>
      <div class="guide_content" v-show="tabNum==3">
        <div class="guide_item" v-for="tour in tourList" @click="goguide(tour.id)">
          <div class="guide_left"><img :src="tour.iconUrl" alt=""></div>
          <div class="guide_right">
            <div class="g1 ellipse">{{tour.name}}</div>
            <div class="g2"><span v-for="la in tour.label.split(',')">{{la}}</span></div>
            <div class="g3"><span>{{tour.collectionNum}}件藏品</span><img src="../assets/erji.png" alt=""><span>{{tour.listenNumber}}</span></div>
          </div>
        </div>
      </div>
      <!--<p class="cp_zhan">展览</p>
      <div class="c_banner">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="items in spreadtrums" @click="goRouter('zhanlan',items.id)">
              <img :src="items.picUrl" alt="" class="slideLeft">
              <div class="slideRight">
                <p class="headline">{{items.headline}}</p>
                <p class="zhanlanadress">{{items.viMoveUrl}}</p>
                <p class="zhanlantime" v-if="items.exhibitionType==0">{{items.beginDate}}-{{items.endDate}}</p>
                <p class="zhanlantime" v-else>常设展览</p>
                <p class="zhanlanlimit"  v-if="items.exhibitionType==0">{{items.closeDays}}天后闭展</p>
                <p class="zhanlanlimit" v-else></p>
              </div>
            </div>
          </div>
        </div>
    </div>-->
      <!--<p class="cp_cangp">藏品</p>
      <div class="b_banner">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="items in collections" @click="goRouter('cangp',items.id)">
              <img :src="items.pics[0].url" alt="" class="slideLeft" >
              <span class="cangp_name ellipse">{{items.name}}</span>
            </div>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
  import {api} from '../global/api';
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import { Indicator } from 'mint-ui';
  import { Toast } from 'mint-ui';
  import { MessageBox } from 'mint-ui';
  export default {
    name: "collection-detail",
    data(){
      return{
        defaultImg: 'this.src="' + require('@/assets/images/no-data.png') + '"',  // 默认图片

        id:"",
        detail:{},//详情数据
        collections:[],
        spreadtrums:[],
        tourList:[],
        isRecording:false,
        isCollect:false,
        latitude:"",
        longitude:"",
        tabList:["简介","展览","藏品","导览"],
        tabNum:0
      }
    },
    mounted(){
      this.init();
      //this.swiper();
    },
    methods:{
      back(){
        this.$router.go(-1);
      },
      goRouter(str,id){
        switch(str)
        {
          case "zhanlan":
            this.$router.push({
              path: 'zhanlanDetail',
              query: { id: id }
            });
            break;

          case "cangp":
            this.$router.push({
              path: 'collectionDetail',
              query: { id: id }
            });
            break;

          case "map":
            this.$router.push({path:"addressMap",query:{latitude:this.latitude,longitude:this.longitude}});
            break;
        }
      },
      swiper(){
        var mySwiper = new Swiper('.c_banner .swiper-container', {
          loop:false,
          slidesPerView:1.2,
          spaceBetween:between()/2,
          initialSlide :0,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          on: {
            init: function(){
              //Swiper初始化了
              // setTimeout(function(){document.getElementsByClassName("swiper-wrapper")[0].style.transform="translate3d(0px,0px,0px)"},500);
              setTimeout(function(){$(".swiper-wrapper").eq(0).css('transform',"translate3d(0px,0px,0px)")},500);
              console.log(1111)
            },
          }

        });
        var mySwiper1 = new Swiper('.b_banner .swiper-container', {
          loop:false,
          slidesPerView:2.2,
          spaceBetween:between(),
          initialSlide :0,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          on: {
            init: function(){
              setTimeout(function () {
                console.log(11111);
              })
              //Swiper初始化了
              // setTimeout(function(){document.getElementsByClassName("swiper-wrapper")[0].style.transform="translate3d(0px,0px,0px)"},500);
              setTimeout(function(){$(".swiper-wrapper").eq(1).css('transform',"translate3d(0px,0px,0px)")},500);
              console.log(1111)
            },
          }
        })
      },
      collect(){
        let that = this;
        this.id = this.$route.query.id;
        let params={"userID":localStorage['userid'],"token":localStorage['token'],"collectID":this.id,"type":2};
        if(this.isCollect==true){
          this.$http.get(api.delCollect, {params:params}).then(response  => {

            if(response.data.success==1){
              this.isCollect=false;
              let instance = Toast(
                {
                  message: '取消成功！',
                  position: 'center',
                  duration: 5000,
                  iconClass: 'icon icon-success'
                }
              );
              setTimeout(() => {
                instance.close();
              }, 2000);

            }else if(response.data.success==999){

              this.$router.push({ path: 'my/login'});

            }else{

              this.isCollect=false;
              let instance = Toast(
                {
                  message: '取消失败！',
                  position: 'center',
                  duration: 5000,
                  iconClass: 'icon icon-fail'
                }
              );
              setTimeout(() => {
                instance.close();
              }, 2000);
            }
          }, response => {
            console.log("请求失败了");
          })
        }else{
          this.$http.get(api.addCollect, {params:params}).then(response  => {

            if(response.data.success==1){
              this.isCollect=true;
              let instance = Toast(
                {
                  message: '收藏成功！',
                  position: 'center',
                  duration: 2000,
                  iconClass: 'icon icon-success'
                }
              );
              setTimeout(() => {
                instance.close();
              }, 2000);

            }else if(response.data.success==999){
              MessageBox.confirm('', {
                message: '登录后收藏，<br>是否现在去登录？',
                title: '',
                confirmButtonText: '稍后',
                cancelButtonText: '登录'
              }).then(action => {
                if (action == 'confirm') {     //确认的回调

                }else{
                  that.$router.push({ path: 'my/login'});
                }
              }).catch(err => {
                if (err == 'cancel') {     //取消的回调
                  that.$router.push({ path: 'my/login'});
                }
              });
             // this.$router.push({ path: 'my/login'});

            }else{
              this.isCollect=false;
              let instance = Toast(
                {
                  message: '收藏失败！',
                  position: 'center',
                  duration: 2000,
                  iconClass: 'icon icon-fail'
                }
              );
              setTimeout(() => {
                instance.close();
              }, 2000);
            }
          }, response => {
            console.log("请求失败了");
          })
        }



      },
      checkRecord(){
        this.isRecording=!this.isRecording;
        var music = document.getElementById("audio");
        if(music.paused){
          music.play();
        }else{
          music.pause();
        }
      },
      init(){
        let that = this;
        this.id = this.$route.query.id;
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        this.$http.get(api.mumDetail+"?museumId="+that.id+"&&userid="+localStorage['userid'], {timeout:8000}).then(response  => {
          // console.log(response.data.subjects);
          Indicator.close();
          if(response.data.data.museumDetail.iscollection){

            response.data.data.museumDetail.iscollection==0?that.isCollect=false:that.isCollect=true;
          }
            //response.data.data.iscollection?that.isCollect=false:that.isCollect=true;
           // response.data.data.iscollection?Vue.set(that.isCollect, false):Vue.set(that.isCollect, true);
          that.detail = response.data.data.museumDetail;
          that.tourList=response.data.data.tourList;
          that.collections = response.data.data.collections;
          that.spreadtrums = response.data.data.spreadtrums;
          that.latitude=response.data.data.museumDetail.latitude;
          that.longitude=response.data.data.museumDetail.longitude;
          // console.log(that.showingDates);
        }, response => {
          console.log("请求失败了");
        })
      },
      tabChange(index){
        this.tabNum=index;
      },
      goguide(id){
        this.$router.push({path:'/guideDetail',query:{id:id}});
      }
    }
  }
</script>

<style scoped="">
  .header{
    width:100%;
    height: 2.25rem;
    background-color: rgba(196, 77, 65, 1);
    position: fixed;
    top: 0;
    z-index: 100;
  }
  .header span{
    display: block;
  }
  .h_title{
    height:  2.25rem;
    line-height:  2.25rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    width: 9rem;
    margin: 0 auto;
    overflow: hidden;
  }
  .h_back{
    background: url("../../static/images/cp_backbtn.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    position: absolute;
    left: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .h_chack{
    width: 1rem;
    height: 1rem;
    position: absolute;
    right: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .off{
    background: url("../../static/images/checkoff.svg") center no-repeat;
    background-size: 100% 100%;
  }
  .on{
    background: url("../../static/images/checkon.svg") center no-repeat;
    background-size: 100% 100%;
  }
  .h_msg{
    width: 17.25rem;
    padding: 1rem .75rem;
    margin-top: 2.25rem;
  }
  .h_img{
    position: relative;
    text-align: center;
  }
  .h_imgbg{
    width: 17.25rem;
    height: 12.9rem;
    border-radius: 0.5rem;
    display: block;
  }
  .recorder{
    position: absolute;
    right: .6rem;
    top: .45rem;
    width: 2.1rem;
    height: 2.1rem;
  }
  .cp_name{
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    margin-top: 1rem;
    margin-bottom: .5rem;
  }
  .cp_base:after{
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
  .cp_base li{
    float: left;
    width: 16rem;
    height: .7rem;
    border-radius: 0.4rem;
    background-color: rgba(241, 241, 242, 1);
    margin-bottom: .5rem;
    padding: .6rem;
  }
  .cp_base img{
    display: inline-block;
    width: .8rem;
    height: .8rem;
    padding-bottom: .2rem;
  }
  .cp_base span{
    width: 12rem;
    height:.8rem;
    line-height:.9rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    vertical-align: top;
    font-family: PingFang-SC-Regular;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    display: inline-block;
    margin-left: .25rem;
  }
  .gotomap{
    width: .34rem;
    height: .6rem;
    position: absolute;
    right:.65rem;
    top: 0;
    bottom:0;
    margin: auto;
    padding-bottom: 0!important;
  }
  .mapnav{
    position: absolute;
    right:1.5rem;
    top: 0;
    bottom:0;
    margin: auto;
    width: 1.2rem;
    text-align: right!important;
    height: .8rem;
  }
  .mum_li{
    position: relative;
  }
  .cp_indroduce{
    width: 3.2rem;
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    margin-top: .5rem;
    margin-bottom: .75rem;
  }
  .cp_content{
    width: 100%;
    line-height: 1.2rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: justify;
    font-family: PingFang-SC-Regular;
    margin-top: 1rem;
  }
  .cp_zhan,.cp_cangp{
    width: 3.2rem;
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    margin-top: .5rem;
    margin-bottom: .75rem;
  }
  .c_banner{
    width: 100%;
    height: 6.25rem;
  }
  .zhanlan_item{
    width: 15.45rem;
    height: 4.5rem;
    border-radius: 0.5rem;
    background-color: rgba(241, 241, 242, 1);
    padding: .9rem .55rem .85rem .55rem;
  }
  .zhanlan_item p{
     width: 8.7rem;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    text-align: left;
  }
  .zhanlan_item .slideLeft{
    display: inline-block;
    width: 5rem;
    height: 4.5rem;

  }
  .slideRight{
    display: inline-block;
    margin-left: .1rem;
    vertical-align: top;
  }
  .headline{
    line-height: 0.7rem;
    height: .75rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    font-family: PingFang-SC-Regular;
    margin-bottom: .45rem;
  }
  .zhanlanadress,.zhanlantime,.zhanlanlimit{
    height: 0.75rem;
    line-height: 0.65rem;
    color: rgba(153, 153, 153, 1);
    font-size: 0.65rem;
    font-family: PingFang-SC-Regular;
    margin-bottom: .25rem;
  }

  .swiper-slide{
    width: 8rem;
    height: 9.35rem;
    position: relative;
  }
  .swiper-slide img{
    width: 8rem;
    height: 8.13rem;
    border-radius: 0.4rem;
  }
  .swiper-slide span{
    width: 100%;
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFang-SC-Regular;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    display: inline-block;
  }
  .nav_item{
    wdith:100%;
  }
  .nav_item span{
    /* width:1.6rem; */
    height:1.2rem;
    font-size:0.8rem;
    font-family:PingFang-SC-Regular;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:0.7rem;
    margin-left: 3.5rem;
    display:inline-block;
  }
  .nav_item span:nth-child(1){
    margin-left: 0;
  }
  .nav_item span.active{
    border-bottom: 0.1rem solid rgba(202,97,87,1);
    color: rgba(202,97,87,1);
  }
  .zhanlan_item{
    width: 16.15rem;
    height: 4.5rem;
    border-radius: 0.5rem;
    background-color: rgba(241, 241, 242, 1);
    padding: .9rem .55rem .85rem .55rem;
    margin-top: 1rem;
  }
  .collect_content:after{
    display: block;
    content: '';
    clear: both;
  }
  .collect_item{
    float: left;
    width: 8rem;
    margin-right: 1.25rem;
    margin-top: 1rem;
  }
  .collect_item img{
    width: 8rem;
    height: 8rem;
    border-radius: 0.4rem;
  }
  .collect_item p{
    width:7.7rem;
    height:0.7rem;
    font-size:0.7rem;
    font-family:PingFang-SC-Regular;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:0.7rem;
    margin-top: 1rem;
  }
  .collect_item:nth-child(2n){
    margin-right: 0;
  }
  .guide_item{
    width: 15.75rem;
    height: 4.75rem;
    padding: 0.75rem;
    margin: 1rem auto 0;
    background:rgba(241,241,242,1);
    border-radius:0.5rem;
  }
  .guide_left{
    float: left;
    width:6rem;
    height:4.5rem;
  }
  .guide_left img{
    width:6rem;
    height:4.5rem;
  }
  .guide_right{
    float: right;
    width: 9rem;
  }
  .g1{
    width:9.25rem;
    height:0.7rem;
    font-size:0.7rem;
    font-family:PingFang-SC-Regular;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:0.7rem;
  }
  .g2{
    margin-top: 0.55rem;
  }
  .g2 span:nth-child(1){
    margin-left: 0;
  }
  .g2 span{
    margin-left: 1rem;
    display: inline-block;
    padding: 0 0.4rem;
    height: 0.9rem;
    line-height: 0.9rem;
    font-size:0.65rem;
    font-family:PingFang-SC-Regular;
    font-weight:400;
    color:rgba(151,151,151,1);
    border-radius:0.6rem;
    border: 0.05rem solid rgba(151,151,151,1);
  }
  .g3{
    margin-top: 0.65rem;
    height:0.6rem;
    font-size:0.65rem;
    font-family:PingFang-SC-Regular;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:0.6rem;
  }
  .g3 img{
    width: 0.8rem;
    height: 0.8rem;
    transform: translateY(2px);
    margin-left: 1.5rem;
    margin-right: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/mumDetail.vue